module.exports = __webpack_public_path__ + "img/android5Button.d8ef8199.png";